import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserScans, setSelectedScan } from '../../actions/scan';
import { withCarousel } from '../../utils/hocs/withCarousel';
import useLocalize from '../../utils/hooks/useLocalize';
import CannedScanCard from './CannedScanCard';
import ScanCard from './ScanCard/ScanCard';

const SavedPresetScansSection = () => {
  const [activeTab, setActiveTab] = useState('preset');
  const isMyScansTab = activeTab === 'myscans';
  const dispatch = useDispatch();
  const localize = useLocalize();
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const userScans = useSelector((state) => state.scans.userScans || []);
  const staticScans = useSelector((state) => state.scans.staticScans || []);
  const activeScanFromStore = useSelector(
    (state) => state.scans.selectedScan || null
  );
  const isLoading = useSelector((state) => state.scans.isLoading || false);

  useEffect(() => {
    dispatch(fetchUserScans());
  }, [dispatch]);

  const handleScanDetailsClick = () => {
    // TODO: Open the details popup with a follow up story
  };

  const handleScanActionsMenuClick = () => {
    // TODO: Open the actions menu with a follow up story
  };

  const handleScanCardClick = (scan) => {
    if (activeScanFromStore && activeScanFromStore.id === scan.id) {
      return;
    }
    dispatch(setSelectedScan(scan));
  };

  const MyScansList = () => (
    <>
      {userScans.map((scan) => (
        <ScanCard
          key={scan.id}
          scan={scan}
          onDetailsClick={handleScanDetailsClick}
          onActionsMenuClick={handleScanActionsMenuClick}
          onClick={() => handleScanCardClick(scan)}
          active={activeScanFromStore && activeScanFromStore.id === scan.id}
        />
      ))}
    </>
  );

  const MyScansCarousel = withCarousel(MyScansList);

  const PresetScansList = () => (
    <>
      {staticScans.map((scan) => (
        <CannedScanCard
          key={scan.id}
          title={scan.name}
          description={localize(`desktop.scans.${scan.id}`) || ''}
          onClick={() => handleScanCardClick(scan)}
          active={activeScanFromStore && activeScanFromStore.id === scan.id}
        />
      ))}
    </>
  );

  const PresetScansCarousel = withCarousel(PresetScansList);

  const renderMyScansContent = () => {
    if (isLoading) {
      return localize('desktop.scans.myscans.construction');
    }

    if (!userScans || userScans.length === 0) {
      return localize('desktop.scans.myscans.empty');
    }

    return (
      <MyScansCarousel
        sectionClass="carousel-section"
        wrapperClass="carousel-wrapper"
        scrollerClass="scan-cards-carousel"
        dotsClass="carousel-dots"
        dotClass="carousel-dot"
        activeDotClass="active"
        deps={[userScans.length]}
      />
    );
  };

  const renderPresetScansContent = () => {
    if (isLoading) {
      return (
        <div className="placeholder-text">
          {localize('desktop.scans.recommended.construction')}
        </div>
      );
    }

    if (!staticScans || staticScans.length === 0) {
      return (
        <div className="placeholder-text">
          {localize('desktop.scans.recommended.empty')}
        </div>
      );
    }

    return (
      <PresetScansCarousel
        sectionClass="carousel-section"
        wrapperClass="carousel-wrapper"
        scrollerClass="canned-scan-cards-carousel"
        dotsClass="carousel-dots"
        dotClass="carousel-dot"
        activeDotClass="active"
        deps={[staticScans.length]}
      />
    );
  };

  const renderTabContent = () => {
    const hasCards = staticScans && staticScans.length > 0 && !isLoading;
    return (
      <div
        className={`saved-preset-tab-content ${isMyScansTab ? 'with-carousel' : ''} ${!isMyScansTab && hasCards ? 'with-carousel' : ''}`}
      >
        {isMyScansTab ? renderMyScansContent() : renderPresetScansContent()}
      </div>
    );
  };

  return (
    <div className="saved-preset-scans-section">
      <div className="saved-preset-tabs">
        <div className="saved-preset-tabs-header">
          <button
            className={`saved-preset-tab ${activeTab === 'preset' ? 'active' : ''
              }`}
            onClick={() => handleTabChange('preset')}
          >
            {localize('desktop.scans.tab.recommended')}
          </button>
          <button
            className={`saved-preset-tab ${activeTab === 'myscans' ? 'active' : ''
              }`}
            onClick={() => handleTabChange('myscans')}
          >
            {localize('desktop.scans.tab.myscans')}
          </button>
        </div>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default SavedPresetScansSection;
